export const spacing = {
  xxs: "2px",
  xs: "4px",
  sm: "8px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "48px"
};



// WEBPACK FOOTER //
// ./src/design-system/theme/spacing.js